import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StateService } from '@uirouter/angular';
import { UiService } from '../../services/core.ui.service';
import { SiteConfigService } from '../../services/core.site-config.service';
import { doGetPromise } from '../../config/core.httpclient-utils';
import * as _ from 'lodash-es';
import { UserService } from '../../services/core.user.service';

declare var $: any;

@Component({
    selector: 'gf-app',
    template: require('./home.html')
})
export class AppComponent implements OnInit {
    @Input() projectMenu: any;
    @Input() chatPermission: any;

    siteConfig: any;
    hasUser = false;

    constructor(
        private httpClient: HttpClient,
        private stateService: StateService,
        private uiService: UiService,
        private siteConfigService: SiteConfigService,
        private userService: UserService
    ) {}

    ngOnInit() {
        this.loadSiteConfig().then(() => {
            const stateParams = this.stateService.params;
            if (stateParams.msg) {
                this.uiService.message.showWarning(stateParams.msg, 'Login Error');
                this.stateService.go('.', { msg: null });
            }
            this.hasUser = this.userService.session.hasUser();
        });
    }

    private loadSiteConfig(): Promise<any> {
        this.siteConfig = this.siteConfigService.getSiteConfig();

        if (this.siteConfig && Object.keys(this.siteConfig).length > 0) {
            return Promise.resolve(this.siteConfig);
        }

        const siteConfigUrl = '/site/config';
        return doGetPromise(this.httpClient, siteConfigUrl)
            .then((data) => {
                this.siteConfigService.setSiteConfig(data);
                this.siteConfig = data;

                // Apply custom CSS if configured
                const customCssUrl = _.get(this.siteConfig, 'customCssUrl', '');
                if (customCssUrl !== '') {
                    const customLink = `<link rel="stylesheet" href="${customCssUrl}"></link>`;
                    $('head').append(customLink);
                }

                return data;
            })
            .catch((error) => {
                console.error('Failed to load site config:', error);
                this.siteConfig = {};
                return {};
            });
    }
}